/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */

import PropTypes from "prop-types";
import React, { Component, createRef } from "react";
import Lottie from "lottie-react";
import { withRouter } from "react-router-dom";
import _ from "underscore";
// REDUX
import { connect } from "react-redux";
// GRAPHQL
import { v4 as uuidv4 } from "uuid";
import * as orderRepo from "../../shared/repos/graphql/order";
import { checkStoreProductStock } from "../../shared/repos/graphql/product";
import ReCAPTCHAForm from "../ReCaptcha/ReCaptcha";
// REDUX
import * as addressActions from "../../redux/actions/address";
import * as countryActions from "../../redux/actions/country";
import * as elementsActions from "../../redux/actions/elements";
import * as userActions from "../../redux/actions/user";
import { store as mainStore } from "../../redux/store";
import { setCaptchaToken } from "../../shared/utilities/captcha";
import {
  openCartCreateFailModal,
  openOrderUpdateFailModal,
  openUnavailableProductModal,
} from "../../shared/utilities/modals";
import {
  guardOrderChange,
  guardOrderChangeLocation,
} from "../../shared/utilities/orders";
import amplitudeAnalytics from "../../shared/utilities/amplitude";
// COMPONENTS
import DeliveryLocationsListItem from "../DeliveryLocationsListItem/DeliveryLocationsListItem";
import FeaturedLocation from "../FeaturedLocation/FeaturedLocation";
import Loader from "../Loader/Loader";
import LocationsListItem from "../LocationsListItem/LocationsListItem";
import removeProductModal from "../RemoveProductModal/RemoveProductModal";
// HELPERS
import * as locationsRepo from "../../shared/repos/graphql/locations";
import * as storeRepo from "../../shared/repos/graphql/store";
import * as userRepo from "../../shared/repos/graphql/user";
import { setSessionToken } from "../../shared/utilities/config";
import {
  GeocodeInit,
  getCurrentPosition,
} from "../../shared/utilities/geolocation";
import * as tagmanagerEvents from "../../shared/utilities/tagmanagerEvents";

import errorCodes from "../../shared/constants/errorCodes";
import { orderMethods, orderTypeIds } from "../../shared/constants/order";
import { shippingMethods, storeIds } from "../../shared/constants/store";

import { resetCurrencyData } from "../../redux/actions/currency";
import { resetCustomCakeTopperData } from "../../redux/actions/customCakeTopper";
import captchaAction from "../../shared/constants/captchaAction";
import cmsKeys from "../../shared/constants/cms";
import { PROVIDERS } from "../../shared/constants/common";
import elementConstants from "../../shared/constants/element";
import endpoints from "../../shared/constants/endpoints";
import httpStatusConstant from "../../shared/constants/httpStatus";
import siteSetting from "../../shared/constants/siteSetting";
import { getSiteSettings } from "../../shared/repos/graphql/siteSetting";
import {
  clearStorage,
  getErrorMessages,
  getErrorReasons,
  routeCountryPath,
} from "../../shared/utilities/common";
import { resolveAmplitudePageName } from "../../shared/utilities/amplitudePageMapping";
import SavedLocations from "../SavedLocation/SavedLocations";
import styles from "./DeliveryPickUpWidget.module.css";
import "./DeliveryPickUpWidgetBrandRefresh.module.css";
import {
  getWidgetPartProps,
  getWidgetRegionProps,
  getCurrentLocationIcon,
  getClearDarkIcon,
  getMapLightIcon,
  getMapPinIcon,
  getNationwideIcon,
  isDeliveryPickupBrandRefresh,
} from "./deliveryPickupWidgetBrandRefreshClasses";
import { getCartErrorMessage } from "../../shared/utilities/cart";

const currentIcon = require("./imgs/current-icon.png");
const searchIcon = require("./imgs/search-icon.png");

const locationIcon = require("./icons/map-pin.svg");
const brandRefreshMapPinIcon = require("./icons/brand-refresh-map-pin.svg");
const clearIcon = require("./imgs/clear-icon.png");
const clearDarkIcon = require("./imgs/clear-dark-icon.svg");
const brandRefreshClearDarkIcon = require("./imgs/brand-refresh-clear-dark-icon.svg");

const crosshairIcon = require("./icons/crosshair.svg");
const brandRefreshCurrentIcon = require("./imgs/brand-refresh-current-icon.svg");
const bakeryAnimation = require("./icons/bakery.json");
const truckAnimation = require("./icons/truck.json");
const brandRefreshDeliveryIcon = require("./icons/brand-refresh-delivery.svg");
const brandRefreshPickupIcon = require("./icons/brand-refresh-pickup.svg");
const StorePickupIcon = require("./icons/store-pickup.svg");
const NationwideIcon = require("./icons/nationwide.svg");
const brandRefreshNationwideIcon = require("./icons/brand-refresh-nationwide.svg");
const brandRefreshWarningCircleIcon = require("./icons/brand-refresh-warning-circle.svg");
const MapLightIcon = require("./imgs/map-light.svg");
const brandRefreshMapLightIcon = require("./imgs/brand-refresh-map-light.svg");
// const RightCircleRight = require("./icons/arrow-circle-right.png");

export class DeliveryPickUpWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLocations: false,
      delivery: true,
      inputValue: props.inputValue,
      stores: [],
      myLocation: { lat: null, lng: null, externalId: "" },
      myAddress: null,
      locationLoading: false,
      selectedLocation: {},
      savedLocations: [],
      locationLabels: [],
      recentAddressesLoading: false,
      favoriteBakeries: [],
      updateOrderLoading: false,
      postCodeSearchModeData: {
        address: "",
        postalCode: "",
        enabled: false,
        lat: null,
        lng: null,
        customAddress: "",
        externalId: null,
      },
      locationDisabled: false,
      outOfDeliveryRange: false,
      hasCaptchaError: false,
      showCaptchaChallenge: false,
      skipGenerateNewToken: false,
      selectedSavedLocation: null,
      clearLocationOnSelect: true, //eslint-disable-line
      addressSource: null,
    };

    this.inputDeliveryAddressRef = createRef();
    this.inputPickupAddressRef = createRef();
    this.recaptchaRef = React.createRef();
    this.recaptchaComponentRef = React.createRef();
    this.fallbackRef = React.createRef();
    this.container = null;
    /** @type {'Search'|'Current Location'|'Saved Address'|null} */
    this.pendingAddressSource = null;
    /** Amplitude Page Name when the widget opened; stable after in-widget navigation. */
    this.enterAddressPageName = null;
  }

  async componentDidMount() {
    const {
      addressType,
      useRecaptcha,
      setVerificationToken,
      setVerificationAction,
    } = this.props;
    const { skipGenerateNewToken } = this.state;
    setSessionToken(uuidv4());
    const { location } = this.props;
    this.enterAddressPageName =
      resolveAmplitudePageName(location?.pathname || "") || "Other";

    if (useRecaptcha === 1) {
      await setCaptchaToken(
        setVerificationToken,
        setVerificationAction,
        captchaAction.addressSearching,
        skipGenerateNewToken,
      );
    }
    await this.getSavedLocations();

    this.setState(
      {
        delivery: addressType !== "pickup",
      },
      () => {
        this.emitViewDeliveryPickupWidget();
      },
    );

    this.container = document.querySelector("#modalDeliveryPickupWidget");

    if (this.container) {
      this.container.setAttribute("tabindex", "0");
      // Don't auto-focus or add focusout listener - causes issues with FocusTrap
    }

    // Add global Esc key listener to ensure modal closes
    this.handleEscKey = (e) => {
      if (this.isExternalModalOpen()) {
        return;
      }
      if (e.key === "Escape" || e.key === "Esc") {
        e.preventDefault();
        e.stopPropagation();
        this.handleCloseWidget();
      }
    };
    document.addEventListener("keydown", this.handleEscKey);
  }

  componentDidUpdate() {
    // Auto-focus disabled - causes issues with FocusTrap
  }

  getAmplitudeFulfillmentTypeLabel = () => {
    const { addressType, location } = this.props;
    const { delivery } = this.state;
    const path = location?.pathname || "";
    // Prefer widget mode over stale Redux userOrderMethod so Shipping does not
    // leak into Delivery/Pickup events after leaving the shipping flow (#18398).
    if (addressType === "shipping" || path.includes(endpoints.shippingPage)) {
      return "Shipping";
    }
    return delivery ? "Delivery" : "Pickup";
  };

  getAnalyticsPageSectionOrDefault = () => {
    const { analyticsPageSection, isModal, productId } = this.props;
    if (analyticsPageSection) {
      return analyticsPageSection;
    }
    if (isModal && productId) {
      return "Product Image";
    }
    return "Nav";
  };

  emitViewDeliveryPickupWidget = () => {
    const { location, userAddress, selectedStore } = this.props;
    const { delivery } = this.state;
    const pageName =
      resolveAmplitudePageName(location?.pathname || "") || "Other";
    const addressChange = delivery
      ? Boolean(userAddress?.address1?.trim())
      : Boolean(selectedStore?.name);
    amplitudeAnalytics.trackViewDeliveryPickupWidget({
      fulfillmentType: this.getAmplitudeFulfillmentTypeLabel(),
      pageName,
      pageSection: this.getAnalyticsPageSectionOrDefault(),
      addressChange,
    });
  };

  emitEnterAddress = (addressLike, addressSource) => {
    const { location } = this.props;
    const pageName =
      this.enterAddressPageName ||
      resolveAmplitudePageName(location?.pathname || "") ||
      "Other";
    amplitudeAnalytics.trackEnterAddress({
      pageName,
      fulfillmentType: this.getAmplitudeFulfillmentTypeLabel(),
      addressSource,
      address: addressLike,
    });
  };

  consumeEnterAddressSource = (selectedSavedLocation) => {
    const { addressSource } = this.state;
    if (selectedSavedLocation) {
      return "Saved Address";
    }
    return this.pendingAddressSource || addressSource || "Search";
  };

  isExternalModalOpen = () => {
    const { modalObject } = this.props;
    return Boolean(modalObject);
  };

  handleFocusOut = () => {
    // Disabled - causes infinite loop with FocusTrap
  };

  componentWillUnmount = () => {
    // Don't remove listener since we never added it
    // if (this.container) {
    //   this.container.removeEventListener("focusout", this.handleFocusOut);
    // }
    // Remove global Esc key listener
    if (this.handleEscKey) {
      document.removeEventListener("keydown", this.handleEscKey);
    }
  };

  setStateDispatchers = () => {
    const {
      setModalObject,
      setUserAddress,
      setSelectedStore,
      setUserOrderMethod,
    } = this.props;
    setSelectedStore(null);
    setUserAddress(null);
    setUserOrderMethod("");
    setModalObject(null);
  };

  historyBack = () => {
    const { setModalObject } = this.props;
    setModalObject(null);
  };

  createCart = async (storeId, address) => {
    const {
      setUserCartId,
      setUserAddress,
      isModal,
      setModalObject,
      setOrderMinAmount,
    } = this.props;
    const { selectedSavedLocation } = this.state;
    const { userCartId } = mainStore.getState().user;
    if (userCartId) {
      return;
    }

    const addressComponents = {
      address1: address.address1,
      city: address.city,
      state: address.state,
      postcode: address.postcode,
      lat: address.lat,
      lng: address.lng,
      dormId: address.dormId,
      countryId: address.countryId,
      address2: address.address2,
    };

    const data = {
      storeId,
      orderTypeId: orderTypeIds.delivery,
      shippingMethod: shippingMethods.delivery,
      address: addressComponents,
    };

    try {
      const response = await orderRepo.createCart(data);
      const { createCart } = response.data;

      setUserCartId(createCart.code);
      setUserAddress({ ...address, savedLocation: selectedSavedLocation });
      const addrSource = this.consumeEnterAddressSource(selectedSavedLocation);
      this.pendingAddressSource = null;
      this.emitEnterAddress(
        { ...address, savedLocation: selectedSavedLocation },
        addrSource
      );
      setOrderMinAmount(createCart.shippingMethodMinAmount);

      if (isModal) {
        setModalObject(null);
      }
    } catch (reason) {
      const message = getErrorMessages(reason, 0);
      const reasonType = getErrorReasons(reason, 0);
      this.handleCartCreateModal(message, reasonType);
    }
  };

  handleCartCreateModal = (message, reason) => {
    const { setModalObject } = this.props;
    const cartCreateError = reason === errorCodes.CART_CREATE_ERROR;
    const updateOrderError = reason === errorCodes.ORDER_UPDATE_ERROR;
    const productAddError = reason === errorCodes.PRODUCT_UPDATE_ERROR;
    const storeComingSoon =
      reason === errorCodes.ADD_PRODUCT_TO_ORDER_STORE_COMING_SOON_ERROR;

    if (cartCreateError) {
      setModalObject(
        openCartCreateFailModal(message, this.setStateDispatchers),
      );
    }

    if (updateOrderError) {
      setModalObject(openOrderUpdateFailModal(message));
    }

    if (productAddError) {
      setModalObject(openUnavailableProductModal(this.historyBack, message));
    }

    if (storeComingSoon) {
      setModalObject(openOrderUpdateFailModal(message));
    }
  };

  handleAddressChange = (store) => {
    const { setSelectedStore } = this.props;
    setSelectedStore(store);
  };

  handlePickupItemSelection = async (location) => {
    const { saveAddress } = this.props;
    this.pendingAddressSource = "Search";
    const { address1, externalId, lat, lng } = location;
    saveAddress([location]);

    this.setState({
      addressSource: "Search",
      myLocation: {
        externalId,
      },
      myAddress: address1,
      showLocations: true,
    });

    const data = {
      lat,
      lng,
      externalId,
    };

    const result = await storeRepo.getStores(data);
    this.getStoresPickupCallback(result.data.storeSearch);
  };

  removeProductModalCallback = async (orderProductIds, store, address) => {
    const { setModalObject, setUserAddress, setUserCart } = this.props;
    const { userCartId } = mainStore.getState().user;
    const { selectedSavedLocation } = this.state;

    const removeProductResponse = await orderRepo.removeProducts(
      userCartId,
      orderProductIds,
    );

    this.handleAddressChange(store);
    setUserAddress({ ...address, savedLocation: selectedSavedLocation });
    const addrSourceRm = this.consumeEnterAddressSource(selectedSavedLocation);
    this.pendingAddressSource = null;
    this.emitEnterAddress(
      { ...address, savedLocation: selectedSavedLocation },
      addrSourceRm
    );
    setUserCart(removeProductResponse.data.removeOrderItemsFromOrder.items);

    const addressComponents = {
      address1: address.address1,
      city: address.city,
      state: address.state,
      postcode: address.postcode,
      lat: address.lat,
      lng: address.lng,
      dormId: address.dormId,
      countryId: address.countryId,
    };

    const data = {
      orderTypeId: orderTypeIds.delivery,
      storeId: store.id,
      address: addressComponents,
    };

    await orderRepo.updateOrderLocation(userCartId, data);

    setModalObject(null);
  };

  /**
   * Handles item selection logic
   */
  handleDeliveryItemSelection = async (
    selectedLocation,
    selectedSavedLocation = null,
  ) => {
    const { saveAddress, addressType, location } = this.props;

    await this.setState({
      onSelectLocationLoader: true,
      selectedSavedLocation,
      addressSource: "Search",
    });

    const {
      lat,
      lng,
      externalId,
      store,
      addressDetails,
      postalCodeValue,
      customAddress,
    } = selectedLocation;

    const postCodeSearchModeData = postalCodeValue
      ? {
          address: selectedLocation.address1,
          postalCode: postalCodeValue,
          enabled: true,
          lat,
          lng,
          externalId,
          customAddress: "",
        }
      : {
          address: "",
          postalCode: "",
          enabled: false,
          lat: null,
          lng: null,
          externalId: null,
          customAddress: "",
        };

    if (postCodeSearchModeData.enabled === false) {
      saveAddress([selectedLocation]);
    }

    const state = {
      selectedLocation,
      myLocation: {
        lat,
        lng,
        externalId,
      },
      postCodeSearchModeData,
      selectedSavedLocation,
      addressSource: "Search",
    };

    await this.setState(state);
    if (store && addressType !== "shipping") {
      await this.handleInRangeDelivery(addressDetails, store);
      this.handleCloseWidget();
      return;
    }

    const data = {
      lat,
      lng,
      externalId,
      orderTypeId: location.pathname.includes(endpoints.shippingPage)
        ? orderTypeIds.shipping
        : orderTypeIds.delivery,
      customAddress,
    };

    const result = await storeRepo.getStores(data);
    if (addressType === "shipping") {
      await this.getShippingAddressTypeCallback(result.data.storeSearch);
    } else {
      await this.getStoresDeliveryCallback(result.data.storeSearch);
    }
  };

  /**
   * Handles delivery type state handling
   * @param {boolean} isDelivery - boolean
   */
  chooseDeliveryType = (isDelivery) => {
    const { useFullyQualifiedAddressForDelivery } = this.props;
    const postCodeSearchModeData = {
      address: "",
      postalCode: "",
      enabled: false,
      lat: null,
      lng: null,
      externalId: null,
      customAddress: "",
    };
    this.setState({ postCodeSearchModeData, delivery: isDelivery });
    const { inputValue } = this.state;
    if (inputValue.length > 0) {
      this.setState({ locationSearchLoading: true });
      this.handleSearch(
        inputValue,
        isDelivery && useFullyQualifiedAddressForDelivery,
      );
    }
  };

  redirectToPdp = (location) => {
    const { redirectUrl, userOrderMethod, redeemables } = this.props;

    const redirectToPdpForDelivery =
      redeemables.redeemableType && userOrderMethod === orderMethods.delivery;
    if (redirectToPdpForDelivery) {
      return routeCountryPath(redirectUrl);
    }

    return location;
  };

  /**
   * Handles input value state setting
   * @param value
   */
  handleInput = (value) => {
    this.setState({ inputValue: value });
  };

  getStoresPickupCallback = (data) => {
    const { addressUpdated } = this.props;
    const { myAddress } = this.state;
    const { address } = data;

    addressUpdated(address);

    this.setState({
      stores: data.stores,
      inputValue: myAddress,
      showLocations: true,
      locationLoading: false,
      locationSearchLoading: false,
      onSelectLocationLoader: false,
    });
  };

  showCountryChange = (
    addressDetails,
    inRangeDelivery,
    shipping,
    store,
    stores,
  ) => {
    const {
      allCountries,
      setSelectedCountry,
      setModalObject,
      isCountrySelectActive,
      history,
    } = this.props;

    if (isCountrySelectActive) {
      const addressCountry = allCountries.find(
        (country) =>
          +country.id === +(store?.countryId || addressDetails.countryId),
      );
      setModalObject({
        title:
          "You are searching for an address in another country, would you like to change your country selection?",
        description:
          "If you remain on the current country website, you may still proceed with ordering, however, all purchases will be completed in the local store currency, and your transaction and your visit to the website will be governed by the local laws.",
        action1: async () => {
          resetCustomCakeTopperData();
          resetCurrencyData();
          userActions.resetUserData();
          clearStorage();
          await setSelectedCountry(addressCountry);
          if (inRangeDelivery === "shipping") {
            shipping();
            window.location.reload();
          } else if (inRangeDelivery) {
            await this.handleInRangeDelivery(addressDetails, store);
            setModalObject(null);
            window.location.reload();
          } else {
            history.push({
              pathname: this.redirectToPdp(
                routeCountryPath(endpoints.locations),
              ),
              state: {
                searchLocation: {
                  lat: addressDetails.lat,
                  lng: addressDetails.lng,
                },
                selectedAddress: addressDetails.myAddress,
                stores,
              },
            });
            setModalObject(null);
          }
        },
        action2: async () => {
          if (inRangeDelivery === "shipping") {
            shipping();
          } else if (inRangeDelivery) {
            await this.handleInRangeDelivery(addressDetails, store);
            setModalObject(null);
          } else {
            history.push({
              pathname: this.redirectToPdp(
                routeCountryPath(endpoints.locations),
              ),
              state: {
                searchLocation: {
                  lat: addressDetails.lat,
                  lng: addressDetails.lng,
                },
                selectedAddress: addressDetails.myAddress,
                stores,
              },
            });
            setModalObject(null);
          }
        },
        action1Label: "Yes",
        action2Label: "No",
      });
    }
    return true;
  };

  handleInRangeDelivery = async (addressDetails, store) => {
    const {
      setSelectedStore,
      setUserOrderMethod,
      setModalObject,
      setUserAddress,
      history,
      isModal,
      setOrderMinAmount,
      setUserCart,
      productId,
      location,
    } = this.props;
    const { selectedSavedLocation } = this.state;

    const { userCartId } = mainStore.getState().user;
    await setUserOrderMethod("DELIVERY");
    const addressComponents = {
      address1: addressDetails.address1,
      city: addressDetails.city,
      state: addressDetails.state,
      postcode: addressDetails.postcode,
      lat: addressDetails.lat,
      lng: addressDetails.lng,
      dormId: addressDetails.dormId,
      countryId: addressDetails.countryId,
      address2: addressDetails.address2,
    };

    await this.createCart(store.id, addressComponents);

    if (userCartId) {
      const response = await checkStoreProductStock(userCartId, store.id);

      const oosIndicator = 1;
      const oosProducts = response.data.storeProductStock.filter(
        (item) => parseInt(item.oos, 10) === oosIndicator,
      );

      if (oosProducts.length) {
        const orderProductIds = _.pluck(oosProducts, "orderProductId");

        return removeProductModal(setModalObject, store, oosProducts, () => {
          this.removeProductModalCallback(
            orderProductIds,
            store,
            addressDetails,
          );
        });
      }

      const updateOrderData = {
        orderTypeId: orderTypeIds.delivery,
        storeId: store.id,
        address: addressComponents,
      };

      try {
        const updateOrderLocation = await orderRepo.updateOrderLocation(
          userCartId,
          updateOrderData,
        );
        setOrderMinAmount(
          updateOrderLocation.data.updateOrder.shippingMethodMinAmount,
        );
        setUserAddress({
          ...addressDetails,
          savedLocation: selectedSavedLocation,
        });
        const addrSourceHr = this.consumeEnterAddressSource(selectedSavedLocation);
        this.pendingAddressSource = null;
        this.emitEnterAddress(
          { ...addressDetails, savedLocation: selectedSavedLocation },
          addrSourceHr
        );
        setSelectedStore(store);
      } catch (reason) {
        const message = getErrorMessages(reason, 0);
        const reasonType = getErrorReasons(reason, 0);
        return this.handleCartCreateModal(message, reasonType);
      }
    } else {
      setSelectedStore(store);
      const { user } = mainStore.getState();

      try {
        if (productId) {
          await orderRepo.addProductToOrderV2(
            user.userCartId,
            { product: productId },
            ({ data }) => {
              const localStorageCart = data?.order?.items?.map((item) => {
                return item;
              });

              setUserCart(localStorageCart);
            },
          );
        }
      } catch (reason) {
        const reasonType = getErrorReasons(reason, 0);
        const message = getCartErrorMessage(reason);
        return this.handleCartCreateModal(message, reasonType);
      }
    }

    if (!isModal) {
      if (!location?.pathname?.includes("/products")) {
        history.push(
          this.redirectToPdp(routeCountryPath(endpoints.getMenuUrl(store))),
        );
      }
    }

    // Reset the loader when address processing is complete
    this.setState({
      onSelectLocationLoader: false,
    });

    return null;
  };

  getSiteSetting = () =>
    new Promise((resolve, reject) => {
      return getSiteSettings([siteSetting.SHIPPING_ACTIVE], true)
        .then((response) => {
          if (!response || !response.data || !response.data.siteSettings) {
            reject(response);
            return;
          }
          resolve(response);
        })
        .catch(reject);
    });

  enablePostcodeSearchMode = () => {
    this.setState({
      inputValue: "",
      locationSearchData: [],
      locationSearchLoading: false,
      locationLoading: false,
      onSelectLocationLoader: false,
    });
  };

  getShippingAddressTypeCallback = async (data) => {
    const { isShippingActive, setAutocompleteSessionToken } = this.props;

    const { selectedLocation, inputValue, postCodeSearchModeData } = this.state;
    const { addressDetails } = selectedLocation;
    const { stores } = data;
    let { address } = data;
    address = address || addressDetails;
    setAutocompleteSessionToken(null);

    // eslint-disable-next-line
    let shippingActiveOverride = isShippingActive;
    if (address) {
      const resp = await this.getSiteSetting();

      const allSettings = resp.data.siteSettings;

      let searchSetting = _.find(allSettings, {
        name: siteSetting.SHIPPING_ACTIVE,
        country_id: address.countryId,
      });

      if (searchSetting === undefined) {
        searchSetting = _.find(allSettings, {
          name: siteSetting.SHIPPING_ACTIVE,
          country_id: null,
        });
      }

      shippingActiveOverride = searchSetting.value === "1";
    }

    if (postCodeSearchModeData.enabled === true) {
      this.enablePostcodeSearchMode();
    } else if (shippingActiveOverride) {
      tagmanagerEvents.outOfDeliveryRange(inputValue, address);
      this.setState({
        locationSearchLoading: false,
        locationLoading: false,
        clearLocationOnSelect: true, // eslint-disable-line
        onSelectLocationLoader: false,
        inputValue: address ? address.address1 : "",
        stores,
        address,
        storeInDeliveryRangeIndex: null,
      });
      this.handleShippingMenu();
    }
  };

  getStoresDeliveryCallback = async (data) => {
    const {
      selectedCountry,
      isCountrySelectActive,
      history,
      location,
      setAutocompleteSessionToken,
    } = this.props;

    const { selectedLocation, inputValue, postCodeSearchModeData } = this.state;
    const { addressDetails } = selectedLocation;
    const { stores } = data;
    let { address } = data;
    address = address || addressDetails;
    setAutocompleteSessionToken(null);
    const storeInDeliveryRangeIndex = data.stores.findIndex(
      (el) => el.inDeliveryRange === true,
    );

    this.setState({
      outOfDeliveryRange: false,
    });
    if (postCodeSearchModeData.enabled === true) {
      this.enablePostcodeSearchMode();
    } else if (storeInDeliveryRangeIndex !== -1) {
      const store = stores[storeInDeliveryRangeIndex];
      this.setState({
        stores,
        address,
        storeInDeliveryRangeIndex: store,
      });
      if (
        isCountrySelectActive === true &&
        +(store?.countryId || address.countryId) !== +selectedCountry.id
      ) {
        this.showCountryChange(address, true, "", store, stores);
        return;
      }
      await this.handleInRangeDelivery(address, store);

      if (!location?.pathname?.includes("/products")) {
        history.push(
          this.redirectToPdp(routeCountryPath(endpoints.getMenuUrl(store))),
        );
      }
      this.handleCloseWidget();
    } else {
      tagmanagerEvents.outOfDeliveryRange(inputValue, address);
      const store = stores[storeInDeliveryRangeIndex];
      this.setState({
        locationSearchLoading: false,
        locationLoading: false,
        outOfDeliveryRange: true,
        clearLocationOnSelect: true, // eslint-disable-line
        onSelectLocationLoader: false,
        inputValue: address.address1,
        stores,
        address,
        storeInDeliveryRangeIndex: store,
        recentAddressesLoading: false,
      });
    }
  };

  handleShippingMenu = () => {
    const { isCountrySelectActive, selectedCountry } = this.props;
    const { address, storeInDeliveryRangeIndex, stores, selectedLocation } =
      this.state;

    this.setState({ onSelectLocationLoader: true });

    if (
      isCountrySelectActive === true &&
      +(storeInDeliveryRangeIndex?.countryId || address?.countryId) !==
        +selectedCountry.id
    ) {
      return this.showCountryChange(
        address,
        "shipping",
        this.handleSelectShipping.bind(this, selectedLocation),
        storeInDeliveryRangeIndex,
        stores,
      );
    }
    return this.handleSelectShipping(selectedLocation);
  };

  viewPickUpMenu = () => {
    const { history, isCountrySelectActive, selectedCountry } = this.props;
    const {
      myAddress,
      stores,
      myLocation,
      address,
      storeInDeliveryRangeIndex,
    } = this.state;

    this.handleCloseWidget();
    if (
      isCountrySelectActive === true &&
      +(storeInDeliveryRangeIndex?.countryId || address?.countryId) !==
        +selectedCountry.id
    ) {
      this.showCountryChange(
        address,
        false,
        "",
        storeInDeliveryRangeIndex,
        stores,
      );
    } else {
      history.push({
        pathname: this.redirectToPdp(routeCountryPath(endpoints.locations)),
        state: {
          searchLocation: {
            lat: stores[0].lat,
            lng: stores[0].lng,
            externalId: myLocation.externalId,
          },
          selectedAddress: myAddress,
          stores,
        },
      });
    }
  };

  outOfDeliveryRangeWidget = () => {
    const { stores } = this.state;
    const { userToken, isShippingActive } = this.props;
    const isBrandRefresh = isDeliveryPickupBrandRefresh();
    const nationwideIcon = getNationwideIcon(
      NationwideIcon,
      brandRefreshNationwideIcon,
    );
    const shippingMessage = isShippingActive
      ? `Good news! Even though your address is out of range, you can still get our cookies at a local store or with a courier${
          isBrandRefresh ? "" : "."
        }`
      : "Unfortunately, this address is outside of delivery range.";
    const onNationwideKeyDown = (e) => {
      if (e.key === "Enter") {
        this.handleShippingMenu(); // eslint-disable-line
      }
    };

    const shippingButtonComponent = isShippingActive ? (
      isBrandRefresh ? (
        <div {...getWidgetPartProps("out-of-range-shipping")}>
          <div {...getWidgetPartProps("out-of-range-icon")}>
            <img src={nationwideIcon} alt="" />
          </div>
          <div {...getWidgetPartProps("out-of-range-copy")}>
            <div {...getWidgetPartProps("out-of-range-headings")}>
              <p {...getWidgetPartProps("out-of-range-title")}>Nationwide Shipping</p>
              <p {...getWidgetPartProps("out-of-range-subtitle")}>Shipped in 2-3 days</p>
            </div>
            <button
              type="button"
              tabIndex="0"
              id="nationwideBtn"
              {...getWidgetPartProps("out-of-range-action")}
              onClick={this.handleShippingMenu}
              onKeyDown={onNationwideKeyDown}
            >
              View menu
            </button>
          </div>
        </div>
      ) : (
        <div
          className="w-full md:w-[274px] h-[220px] px-2 py-4 rounded-[20px]
      flex flex-col gap-3
      border border-borderLight border-solid text-center mx-auto text-dark"
        >
          <img className="mx-auto" src={nationwideIcon} alt="" />
          <div className="font-montserratMedium">
            <p className="text-base font-bold">Nationwide shipping</p>
            <p>
              <span className="w-full text-darkDry text-sm leading-4">
                Shipped in 2-3 days
              </span>
            </p>
          </div>
          <button
            type="button"
            tabIndex="0"
            id="nationwideBtn"
            className={`
      flex flex-row justify-center items-center
      w-[118px] px-2 md:py-3 gap-2 h-11 bg-dark
      rounded-[40px] text-light
      font-montserratBold mx-auto
      `}
            onClick={this.handleShippingMenu}
            onKeyDown={onNationwideKeyDown}
          >
            View menu
          </button>
        </div>
      )
    ) : (
      ""
    );

    return (
      <div className="w-full" id="notInRange" {...getWidgetPartProps("out-of-range")}>
        {isBrandRefresh ? (
          <p {...getWidgetPartProps("out-of-range-message")}>{shippingMessage}</p>
        ) : (
          <div className="w-full">
            {/* eslint-disable-next-line */}
            {!isShippingActive ? (
              <p className="text-sm font-[425] text-dark font-montserratMedium">
                Unfortunately, this address is outside of delivery range.
              </p>
            ) : (
              <p className="text-sm font-[425] text-dark font-montserratMedium">
                Good news! Even though your address is out of range, you can still
                get our cookies at a local store or with a courier.
              </p>
            )}
          </div>
        )}
        <div
          className={
            isBrandRefresh
              ? undefined
              : "flex w-full mt-3 flex-col md:flex-row items-center gap-2"
          }
          {...getWidgetPartProps("out-of-range-options")}
        >
          {stores.length > 0 ? (
            <div
              className="w-full md:w-[274px] h-[220px] px-2 py-4 rounded-[20px]
            flex flex-col gap-3
            border border-borderLight border-solid text-center mx-auto text-dark "
            >
              <img className="mx-auto" src={StorePickupIcon} alt="" />

              <div className="font-montserratMedium">
                <p className="text-base font-bold">Store pickup</p>
                <p>
                  <span className="text-sm leading-4 text-dark">
                    Fresh warm cookies, ready for pickup
                  </span>
                  <span className="text-sm leading-4 text-dark">
                    {stores[0].address}
                    {' '}
-
                    {stores[0].distanceToStore}
                  </span>
                </p>
              </div>

              <button
                type="button"
                id="pickupBtn"
                onClick={() => {
                  this.viewPickUpMenu();
                }}
                tabIndex={0}
                onKeyDown={(e) => e.key === "Enter" && this.viewPickUpMenu()}
                className={`
              flex flex-row justify-center items-center
              w-[118px] px-2 md:py-3 gap-2 h-11 bg-dark
              rounded-[40px] text-light
              font-montserratBold mx-auto
              `}
              >
                View menu
              </button>
            </div>
          ) : null}

          {shippingButtonComponent}
        </div>
        {userToken && (
          isBrandRefresh ? (
            <div {...getWidgetPartProps("out-of-range-alert")}>
              <div {...getWidgetPartProps("out-of-range-alert-icon")}>
                <img src={brandRefreshWarningCircleIcon} alt="" />
              </div>
              <p {...getWidgetPartProps("out-of-range-alert-text")}>
                Reward points can only be redeemed through Delivery or Pickup.
              </p>
            </div>
          ) : (
            <div className="w-full text-center my-4 ">
              <p className="text-sm font-[425] text-button font-montserratMedium px-4 lg:px-0 py-8 bg-red-200 w-72 lg:w-full mx-auto rounded-xl">
                Reward Points can only be redeemed through Delivery or Pickup.
              </p>
            </div>
          )
        )}
      </div>
    );
  };

  handleSelectShipping = async (selectedLocation) => {
    const {
      setUserCartId,
      history,
      setSelectedStore,
      setModalObject,
      setUserOrderMethod,
      setUserAddress,
      userCartId,
    } = this.props;
    const { updateOrderLoading } = this.state;
    if (updateOrderLoading) {
      return;
    }
    this.setState({
      updateOrderLoading: true,
    });

    const orderData = {
      orderTypeId: orderTypeIds.shipping,
      storeId: storeIds.shipping,
      shippingMethod: shippingMethods.shipping,
    };

    const { address, selectedSavedLocation } = this.state;
    const selectedLocationClone = {
      ...selectedLocation,
      savedLocation: selectedSavedLocation,
    };
    if (
      !selectedLocation.externalId &&
      address.address1 === selectedLocation.address1 &&
      address.lat &&
      address.lng
    ) {
      const geocodeResponse = await GeocodeInit.fromLatLng(
        address.lat,
        address.lng,
      );
      if (geocodeResponse && geocodeResponse.results.length > 0) {
        /* eslint-disable camelcase */
        const { place_id } = geocodeResponse.results[0];
        selectedLocationClone.externalId = place_id;
      }
    }
    try {
      if (userCartId) {
        await orderRepo.updateOrderLocation(userCartId, orderData);
        await orderRepo.setShippingAddress(
          userCartId,
          selectedLocationClone.externalId,
        );
      } else {
        const responseCreatCart = await orderRepo.createCart(orderData);
        const orderCode = responseCreatCart.data.createCart.code;
        setUserCartId(orderCode);
        await orderRepo.setShippingAddress(
          orderCode,
          selectedLocationClone.externalId,
        );
      }
      setSelectedStore({
        id: storeIds.shipping,
        name: "Gifts",
        slug: "gifts",
      });
      setUserOrderMethod("SHIPPING");
      setUserAddress(selectedLocationClone);
      const addrSourceShip = this.consumeEnterAddressSource(selectedSavedLocation);
      this.pendingAddressSource = null;
      this.emitEnterAddress(selectedLocationClone, addrSourceShip);
      this.setState({
        updateOrderLoading: false,
      });
      history.push(routeCountryPath(endpoints.shippingPage));
      setModalObject(null);
    } catch (exception) {
      setModalObject(null);
    }
    this.setState({ onSelectLocationLoader: false });
    this.handleCloseWidget({ skipOnCloseCallback: true });
  };

  handleAddressSearch = (value, fullQualified) => {
    this.setState({ inputValue: value, outOfDeliveryRange: false });
    this.handleSearch(value, fullQualified);
  };

  // eslint-disable-next-line react/sort-comp
  handleSearch = _.debounce(async (value, fullyQualified = false) => {
    const {
      userOrderMethod,
      useRecaptcha,
      setVerificationToken,
      setVerificationAction,
      setVerificationProvider,
    } = this.props;
    const showDorms = userOrderMethod !== orderMethods.shipping ?? false;
    const { myLocation, postCodeSearchModeData, skipGenerateNewToken } =
      this.state;
    const searchValue = postCodeSearchModeData.enabled
      ? `${postCodeSearchModeData.address}, ${value}`
      : value;
    postCodeSearchModeData.customAddress = value;
    this.setState({
      postCodeSearchModeData,
      inputValue: value,
    });
    if (searchValue.length < 3) {
      return;
    }
    if (useRecaptcha === 1) {
      await setCaptchaToken(
        setVerificationToken,
        setVerificationAction,
        captchaAction.addressSearching,
        skipGenerateNewToken,
      );
    }
    this.setState({
      locationSearchLoading: true,
      showLocations: false,
    });

    try {
      const { lat, lng } = myLocation;
      let filter = null;
      let fullQualifiedValue = fullyQualified;
      if (postCodeSearchModeData.enabled) {
        filter = postCodeSearchModeData.postalCode;
        fullQualifiedValue = true;
      }
      const result = await locationsRepo.getLocations(
        searchValue,
        lat,
        lng,
        fullQualifiedValue,
        showDorms,
        filter,
      );
      const locations = _.filter(result.data.locationSearch, (item) => {
        return !(
          postCodeSearchModeData.enabled &&
          item.postalCodeValue &&
          item.postalCodeValue === postCodeSearchModeData.postalCode
        );
      });
      this.setState({
        locationSearchData: locations,
      });
      setVerificationProvider("");
    } catch (e) {
      this.setState({
        locationSearchError: e.message,
      });
      const error = e.message;
      const hasUnauthorized = error
        ? error.indexOf(httpStatusConstant.unauthorised) !== -1
        : false;
      if (e.message) {
        this.setState({
          hasCaptchaError: hasUnauthorized,
          showCaptchaChallenge: hasUnauthorized,
          locationSearchData: [],
        });
      } else {
        this.setState({
          showCaptchaChallenge: false,
          hasCaptchaError: false,
          skipGenerateNewToken: false,
        });
      }
    }

    this.setState({
      locationSearchLoading: false,
    });
  }, 500);

  isShowAddressChangeModal = (address1) => {
    const { userAddress } = this.props;
    const selectedAddress = userAddress ? userAddress.address1 : "";
    const showOrderGuardModal = this.getCartItemsCount() > 0;
    return selectedAddress === address1 ? false : showOrderGuardModal;
  };

  getCartItemsCount = () => {
    const { userCart, orderProducts } = this.props;
    const legacyCartCount = Array.isArray(userCart) ? userCart.length : 0;
    const orderProductsCount = Array.isArray(orderProducts)
      ? orderProducts.length
      : 0;
    return Math.max(orderProductsCount, legacyCartCount);
  };

  handleDormLocationSelect = async (location) => {
    const { isModal } = this.props;
    const dormLocation = {
      ...location,
      postalCodeValue: null,
      customAddress: "",
    };
    if (isModal) {
      await this.handleDeliveryItemSelection(dormLocation, location);
    } else {
      const showOrderGuardModal = this.isShowAddressChangeModal(
        dormLocation.addressDetails.address1,
      );
      guardOrderChangeLocation(
        showOrderGuardModal,
        this.handleDeliveryItemSelection,
        dormLocation,
        location,
      );
    }
  };

  handleSavedLocationSelect = async (savedLocation) => {
    const { addressType } = this.props;
    let externalId = null;
    const providerId = savedLocation?.source?.id
      ? +savedLocation.source.id
      : null;
    if (
      [PROVIDERS.GOOGLE_MAP, PROVIDERS.INSOMNIA_COOKIES].indexOf(providerId) !==
        -1 &&
      savedLocation?.sourceId
    ) {
      externalId = savedLocation.sourceId;
    }
    await this.setState({
      recentAddressesLoading: true,
      addressSource: "Saved Address",
      myLocation: {},
      myAddress: null,
      selectedLocation: savedLocation,
      selectedSavedLocation: savedLocation,
    });

    const data = {
      lat: savedLocation.addressDetails.lat,
      lng: savedLocation.addressDetails.lng,
      externalId,
      providerId,
      orderTypeId: addressType === "pickup" ? orderTypeIds.pickup : orderTypeIds.delivery,
    };
    const result = await storeRepo.getStores(data);
    const deliveryData = {
      stores: result.data.storeSearch.stores,
      address: savedLocation.addressDetails,
    };
    if (addressType === "shipping") {
      await this.getShippingAddressTypeCallback(deliveryData);
    } else if (addressType === "pickup") {
      await this.getStoresPickupCallback(deliveryData);
    } else {
      await this.getStoresDeliveryCallback(deliveryData);
    }
  };

  handleSavedLocationLabelClick = async (label) => {
    if (label.locations && label.locations.length > 0) {
      const location = label.locations[0];
      const locationWithLabel = {
        ...location,
        locationLabel: { label: label.label, id: label.id },
      };
      const providerId = location?.source?.id ? +location.source.id : null;
      if (
        providerId === PROVIDERS.INSOMNIA_DORMS &&
        location.store &&
        location.addressDetails.dormId
      ) {
        this.setState({
          recentAddressesLoading: true,
        });
        await this.handleDormLocationSelect(locationWithLabel);
      } else {
        const isShowAddressChangeModal = this.isShowAddressChangeModal(
          location.addressDetails.address1,
        );
        guardOrderChangeLocation(
          isShowAddressChangeModal,
          this.handleSavedLocationSelect,
          locationWithLabel,
        );
      }
    }
  };

  handleSavedLocationsUpdated = (me) => {
    this.setState({
      savedLocations: me.savedLocations,
      locationLabels: me.locationLabels,
    });
  };

  handleSavedLocationClick = async (savedLocation) => {
    const providerId = savedLocation?.source?.id
      ? +savedLocation.source.id
      : null;
    if (
      providerId === PROVIDERS.INSOMNIA_DORMS &&
      savedLocation.store &&
      savedLocation.addressDetails.dormId
    ) {
      this.setState({
        recentAddressesLoading: true,
      });
      await this.handleDormLocationSelect(savedLocation);
    } else {
      const isShowAddressChangeModal = this.isShowAddressChangeModal(
        savedLocation.addressDetails.address1,
      );
      guardOrderChangeLocation(
        isShowAddressChangeModal,
        this.handleSavedLocationSelect,
        savedLocation,
      );
    }
  };

  renderErrorUI = () => (
    <div
      className={styles.errorContainer}
      {...getWidgetPartProps("error-container")}
    >
      <p>Oops, something went wrong</p>
      <p>There was a network error, try refreshing your browser.</p>
      <span onClick={() => window.location.reload()}>Reload Page</span>
    </div>
  );

  renderCaptchaChallenge = () => {
    const { showCaptchaChallenge } = this.state;
    const { useRecaptcha } = this.props;
    return showCaptchaChallenge && useRecaptcha ? (
      <div className={styles.errorContainer}>
        <ReCAPTCHAForm
          ref={this.recaptchaComponentRef}
          setToken={this.onVerifyCaptcha}
        />
      </div>
    ) : (
      <div className="testting" />
    );
  };

  onVerifyCaptcha = (token) => {
    if (token) {
      this.setState({
        showCaptchaChallenge: false,
        skipGenerateNewToken: true,
      });

      const { setVerificationToken, setVerificationProvider } = this.props;
      const { inputValue } = this.state;
      setVerificationToken(token);
      setVerificationProvider(elementConstants.challengeRecaptcha);

      this.handleSearch(inputValue);
    }
  };

  /**
   * Clears delivery input
   */
  clearDeliveryInput = () => {
    this.setState({ inputValue: "", outOfDeliveryRange: false });
  };

  /**
   * Set current location.
   *
   * @param {string} myAddress
   * @param {object} myLocation
   *
   * @author Elizabeth Clouser <elizabeth@somepage.com>
   */
  handleCurrentLocationSelect = async (myAddress, myLocation) => {
    this.pendingAddressSource = "Current Location";
    const { delivery } = this.state;
    const { lat, lng, externalId } = myLocation;
    const { addressType } = this.props;

    const loc = {
      id: null,
      address1: myAddress,
      externalId: externalId || "",
      __typename: "Location",
    };

    this.setState({
      locationLoading: true,
      inputValue: myAddress,
      addressSource: "Current Location",
      selectedSavedLocation: null,
      selectedLocation: loc,
      myAddress,
      myLocation: {
        lat,
        lng,
        externalId,
      },
    });

    const data = {
      lat,
      lng,
      externalId,
      orderTypeId: delivery ? orderTypeIds.delivery : orderTypeIds.pickup,
    };
    const result = await storeRepo.getStores(data);

    if (addressType === "shipping") {
      await this.getShippingAddressTypeCallback(result.data.storeSearch);
    } else if (delivery) {
      await this.getStoresDeliveryCallback(result.data.storeSearch);
    } else {
      await this.getStoresPickupCallback(result.data.storeSearch);
    }
  };

  getSavedLocations = async () => {
    const { userToken } = this.props;
    if (!userToken) {
      return;
    }

    this.setState({
      recentAddressesLoading: true,
    });

    try {
      const response = await userRepo.getSavedLocations();
      const me = response?.data?.me;
      this.setState({
        recentAddressesLoading: false,
        savedLocations: me?.savedLocations,
        locationLabels: me?.locationLabels,
        favoriteBakeries: me?.favoriteStores,
        postCodeSearchModeData: {
          address: "",
          postalCode: "",
          enabled: false,
          lat: null,
          lng: null,
          externalId: null,
          customAddress: "",
        },
      });
    } catch {
      // Keep address setup available even when the saved-location request fails.
      this.setState({
        recentAddressesLoading: false,
        savedLocations: undefined,
        locationLabels: [],
        favoriteBakeries: [],
      });
    }
  };

  selectDeliveryLocation = (location) => {
    const { isModal, userAddress } = this.props;
    const selectedAddress = userAddress ? userAddress.address1 : "";
    let showOrderGuardModal =
      this.getCartItemsCount() > 0 && !location.postalCodeValue;
    showOrderGuardModal =
      selectedAddress === location.address1 ? false : showOrderGuardModal;
    if (isModal) {
      return this.handleDeliveryItemSelection(location, null);
    }

    return guardOrderChangeLocation(
      showOrderGuardModal,
      this.handleDeliveryItemSelection,
      location,
      null,
    );
  };

  selectCustomLocation = () => {
    const { postCodeSearchModeData } = this.state;
    return this.selectDeliveryLocation({
      lat: postCodeSearchModeData.lat,
      lng: postCodeSearchModeData.lng,
      externalId: postCodeSearchModeData.externalId,
      postalCodeValue: null,
      store: null,
      addressDetails: null,
      customAddress: postCodeSearchModeData.customAddress.trim(),
    });
  };

  /**
   * Renders delivery section
   */
  renderDeliverySection = () => {
    const {
      locationLoading,
      inputValue,
      myLocation,
      myAddress,
      locationSet,
      locationSearchData,
      locationSearchError,
      locationSearchLoading,
      savedLocations,
      locationLabels,
      recentAddressesLoading,
      postCodeSearchModeData,
      locationDisabled,
      outOfDeliveryRange,
      onSelectLocationLoader,
      hasCaptchaError,
    } = this.state;

    const {
      userToken,
      isModal,
      cmsContent,
      useFullyQualifiedAddressForDelivery,
      addressType,
    } = this.props;

    if (!myAddress && !locationLoading && !locationSet && !locationDisabled) {
      this.handleCurrentPosition(isModal);
    }
    const showOrderGuardModal = this.getCartItemsCount() > 0;
    const showFeaturedLocation = myLocation.lat && myLocation.lng && myAddress;
    const showUserLocations =
      inputValue.length === 0 &&
      !isModal &&
      postCodeSearchModeData.enabled === false;
    const deliveryAddressPlaceHolder =
      _.find(cmsContent, {
        key: cmsKeys.placeholders.enterDeliveryAddress,
      })?.value || "Enter Delivery Address";
    const shippingAddressPlaceholder =
      _.find(cmsContent, {
        key: cmsKeys.placeholders.enterShippingAddress,
      })?.value || "Enter Shipping Address";
    const isShipping = addressType === "shipping";
    const addressPlaceholder = isShipping
      ? shippingAddressPlaceholder
      : deliveryAddressPlaceHolder;

    const isBrandRefresh = isDeliveryPickupBrandRefresh();
    const mapPinIcon = getMapPinIcon(locationIcon, brandRefreshMapPinIcon);
    const deliveryInputIcon = isBrandRefresh
      ? brandRefreshMapPinIcon
      : !isModal
        ? locationIcon
        : searchIcon;

    const deliveryAddressInputContents = (
      <>
        <img alt="" src={deliveryInputIcon} />
        <input
          id="delivery-widget-enter-delivery-address"
          name="input_delivery_address"
          onChange={(e) =>
            this.handleAddressSearch(
              e.target.value,
              useFullyQualifiedAddressForDelivery,
            )}
          placeholder={
            postCodeSearchModeData.enabled
              ? "Enter Street Address"
              : addressPlaceholder
          }
          value={inputValue}
          className="font-montserratMedium bg-transparent outline-none text-dark inputModeOverride"
          ref={this.inputDeliveryAddressRef}
        />
        {inputValue.length > 0 && !locationSearchLoading ? (
          <button
            type="button"
            onClick={this.clearDeliveryInput}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                this.clearDeliveryInput();
              }
            }}
            aria-label="Clear search"
            className="bg-transparent border-none p-0 cursor-pointer w-4 h-4"
          >
            <img alt="" src={clearIcon} aria-hidden="true" />
          </button>
        ) : null}
      </>
    );

    return (
      <div
        className={`${styles.deliveryContainer} w-full`}
        {...getWidgetPartProps("delivery-container")}
      >
        {postCodeSearchModeData.enabled ? (
          <div className={styles.deliveryPostCodeSearchMessage}>
            <div className={styles.postcodeMessageTitle}>
              {postCodeSearchModeData.address}
            </div>
            <div className={styles.postcodeMessageSubtitle}>
              Please provide your street address:
            </div>
          </div>
        ) : null}
        {isBrandRefresh ? (
          <div {...getWidgetPartProps("delivery-input")}>
            <div {...getWidgetPartProps("delivery-input-row")}>
              {deliveryAddressInputContents}
            </div>
          </div>
        ) : (
          <div
            className={`${styles.deliveryInputContainer} border-solid bg-white border-lightDry border-[1px]`}
          >
            {deliveryAddressInputContents}
          </div>
        )}
        {hasCaptchaError
          ? this.renderCaptchaChallenge()
          : locationSearchError
            ? this.renderErrorUI()
            : null}

        {showUserLocations ? (
          <div
            className={isBrandRefresh ? "w-full" : undefined}
            {...getWidgetPartProps("user-locations")}
          >
            {showFeaturedLocation ? (
              <FeaturedLocation
                onClick={() =>
                  guardOrderChange(
                    showOrderGuardModal,
                    this.handleCurrentLocationSelect,
                    myAddress,
                    myLocation,
                  )}
                icon={getCurrentLocationIcon(currentIcon, brandRefreshCurrentIcon)}
                label="Use my current location"
                value={myAddress}
                dataPart={
                  isDeliveryPickupBrandRefresh() ? "current-location" : undefined
                }
              />
            ) : null}
            {userToken ? (
              <div
                className={`${styles.savedLocation} text-dark`}
                aria-busy={recentAddressesLoading}
                {...getWidgetPartProps("saved-addresses")}
              >
                {isDeliveryPickupBrandRefresh() ? (
                  <div {...getWidgetPartProps("saved-addresses-top")}>
                    <p
                      className="text-darkElevationPrimary font-montserratBold text-lg"
                      {...getWidgetPartProps("section-heading")}
                    >
                      Saved Addresses
                    </p>
                  </div>
                ) : (
                  <p className="text-darkElevationPrimary font-montserratBold text-lg">
                    Saved Addresses
                  </p>
                )}
                {/* Common labels stay visible while saved locations load. */}
                <SavedLocations
                  onLabelClick={this.handleSavedLocationLabelClick}
                  labels={locationLabels?.length ? locationLabels : []}
                  className={[
                    styles.savedAddressesContainer,
                    styles.savedAddressesLabelsContainer,
                    "dark:text-light text-dark deliveryPickupWidgetSavedAddresses",
                  ].join(" ")}
                  onLocationClick={this.handleSavedLocationClick}
                  paginatedLocations={
                    savedLocations?.locations?.length
                      ? savedLocations
                      : undefined
                  }
                  onEditModalVisibilityChange={() => {
                    this.setState({});
                  }}
                  onComponentUpdated={this.handleSavedLocationsUpdated}
                />
              </div>
            ) : null}
          </div>
        ) : null}

        {/* Loader removed - using global loader instead */}

        {inputValue.length < 1 ? null : !locationSearchLoading &&
          locationSearchData &&
          !onSelectLocationLoader &&
          !outOfDeliveryRange &&
          locationSearchData.length > 0 ? (
            <div
              className={
                isDeliveryPickupBrandRefresh() ? "w-full" : undefined
              }
              {...getWidgetPartProps("location-search-results")}
            >
              {locationSearchData.map((location) => (
                <DeliveryLocationsListItem
                  key={location.address1}
                  onClick={() => this.selectDeliveryLocation(location)}
                  coords={{ lat: location.lat, lng: location.lng }}
                  icon={mapPinIcon}
                  address1={
                  location.postalCodeValue
                    ? `${location.postalCodeValue} (click to enter address), ${location.address1}`
                    : location.address1
                }
                  addressDetails={location.addressDetails}
                />
            ))}
            </div>
        ) : null}
        {postCodeSearchModeData.enabled &&
        postCodeSearchModeData.customAddress &&
        !locationSearchLoading ? (
          <div
            className={
              isDeliveryPickupBrandRefresh() ? "w-full" : undefined
            }
            {...getWidgetPartProps("location-search-results")}
          >
            <DeliveryLocationsListItem
              key="postcodeCustom"
              onClick={() => this.selectCustomLocation()}
              coords={{
                lat: postCodeSearchModeData.lat,
                lng: postCodeSearchModeData.lng,
              }}
              icon={mapPinIcon}
              address1={`${postCodeSearchModeData.customAddress}, ${postCodeSearchModeData.address}`}
              addressDetails={null}
            />
          </div>
        ) : null}

        {outOfDeliveryRange && !onSelectLocationLoader
          ? this.outOfDeliveryRangeWidget()
          : null}
      </div>
    );
  };

  handleCurrentPosition = (isModal, callback) => {
    this.setState({
      locationLoading: true,
    });

    getCurrentPosition((response) => {
      if (!response) {
        this.setState({
          locationLoading: false,
          locationDisabled: true,
        });

        return null;
      }
      
      const address = isModal ? null : response.results[0].formatted_address;
      const { coords } = response.position;
      /* eslint-disable camelcase */
      const { place_id } = response.results[0];

      this.setState({
        myAddress: address,
        myLocation: {
          lat: coords.latitude,
          lng: coords.longitude,
          externalId: place_id,
        },
        locationLoading: false,
        locationSet: true,
      });

      if (callback) {
        return callback();
      }
      return null;
    }, this);
  };

  /**
   * Handles showing all locations
   */
  handleAllLocations = () => {
    const { setModalObject } = this.props;
    setModalObject(null);
  };

  /**
   * The store pickup open status.
   *
   * @author Elizabeth Clouser <elizabeth@somepage.com>
   */
  locationIsOpen = (store) => {
    return store.isPickupOpen;
  };

  toLocationsPage = () => {
    const { setModalObject, history } = this.props;
    setModalObject(null);
    history.push(this.redirectToPdp(routeCountryPath(endpoints.locations)));
    this.handleCloseWidget();
  };

  handleCloseWidget = ({ skipOnCloseCallback = false } = {}) => {
    const { onClose, hideHeaderWidget, setModalObject } = this.props;
    if (!skipOnCloseCallback) {
      if (onClose) {
        onClose();
      } else {
        hideHeaderWidget();
      }
    }

    setModalObject(null);
  };

  storeIsselected = (store) => {
    const { selectedStore } = this.props;
    return selectedStore && selectedStore.id === store.id;
  };

  /**
   * Renders pickup section
   */
  renderPickUpSection = () => {
    const { preserveProductPage } = this.props;
    const {
      inputValue,
      myAddress,
      showLocations,
      delivery,
      locationLoading,
      locationSet,
      locationDisabled,
      stores,
      locationSearchLoading,
      locationSearchData,
      locationSearchError,
      myLocation,
      hasCaptchaError,
      favoriteBakeries,
    } = this.state;
    const {
      isModal,
      history,
      showPickUpButton,
      clickPickUpButton,
      selectedPopupStore,
      userToken,
    } = this.props;

    if (!myAddress && !locationLoading && !locationSet && !locationDisabled) {
      this.handleCurrentPosition(isModal);
    }

    const showUserLocations = inputValue.length === 0 && !isModal;
    const showFeaturedLocation = myLocation.lat && myLocation.lng && myAddress;
    const showOrderGuardModal = this.getCartItemsCount() > 0;
    const mapPinIcon = getMapPinIcon(locationIcon, brandRefreshMapPinIcon);
    const isBrandRefresh = isDeliveryPickupBrandRefresh();
    const pickupInputIcon = isBrandRefresh ? mapPinIcon : searchIcon;
    const mapLightIcon = getMapLightIcon(MapLightIcon, brandRefreshMapLightIcon);

    const pickupStoreName = selectedPopupStore?.name;
    const pickupStoreAddress = selectedPopupStore?.address;
    const onViewPickupMenuKeyDown = (e) => {
      if (e.key === "Enter") {
        clickPickUpButton(e);
      }
    };

    const pickupAddressInputContents = [
      <img key="pickup-search-icon" alt="" src={pickupInputIcon} />,
      <input
        key="pickup-search-input"
        id="delivery-widget-enter-pickup-address"
        name="input_pickup_address"
        className="font-montserratMedium bg-transparent outline-none text-dark inputModeOverride"
        onChange={(e) => this.handleAddressSearch(e.target.value)}
        value={inputValue}
        placeholder="Find bakery near you"
        ref={this.inputPickupAddressRef}
      />,
      locationLoading || locationSearchLoading ? (
        <span key="pickup-search-loader" className={`${styles.loaderWrapper}`}>
          {/* Loader removed - using global loader instead */}
        </span>
      ) : (
        <div
          key="pickup-view-on-map"
          role="button"
          tabIndex="0"
          className={
            isBrandRefresh
              ? undefined
              : `hidden md:flex items-center gap-2 cursor-pointer
                 w-[220px] h-8 text-white
               bg-dark rounded-[40px] px-4 py-2
               text-sm leading-4 font-bold font-montserratMedium`
          }
          {...getWidgetPartProps("view-on-map")}
          onClick={this.toLocationsPage}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              this.toLocationsPage(); // eslint-disable-line
            }
          }}
        >
          {isBrandRefresh ? (
            <div {...getWidgetPartProps("view-on-map-content")}>
              <div {...getWidgetPartProps("view-on-map-inner")}>
                <img
                  alt=""
                  src={mapLightIcon}
                  {...getWidgetPartProps("pickup-location-icon")}
                />
                <p>View on map</p>
              </div>
            </div>
          ) : (
            [
              <img
                key="pickup-map-icon"
                className={`${styles.pickupLocationIcon}`}
                alt=""
                src={mapLightIcon}
              />,
              <p key="pickup-map-label">View on map</p>,
            ]
          )}
        </div>
      ),
    ];

    return (
      <div
        className={`${styles.pickUpContainer} w-full`}
        {...getWidgetPartProps("pickup-container")}
      >
        {!showPickUpButton ? (
          isBrandRefresh ? (
            <div {...getWidgetPartProps("pickup-input")}>
              <div {...getWidgetPartProps("pickup-input-row")}>
                {pickupAddressInputContents}
              </div>
            </div>
          ) : (
            <div className={`${styles.pickUpInputContainer} w-full`}>
              <div
                className="border-solid bg-white border-lightDry border-[1px] w-full"
              >
                {pickupAddressInputContents}
              </div>
            </div>
          )
        ) : isBrandRefresh ? (
          <div {...getWidgetPartProps("pickup-popup")}>
            <p {...getWidgetPartProps("pickup-popup-name")}>
              {pickupStoreName}
            </p>
            <p {...getWidgetPartProps("pickup-popup-address")}>
              {pickupStoreAddress}
            </p>
            <button
              type="button"
              {...getWidgetPartProps("pickup-popup-action")}
              onClick={clickPickUpButton}
              onKeyDown={onViewPickupMenuKeyDown}
            >
              View Pickup Menu
            </button>
          </div>
        ) : (
          <div>
            <div className="flex flex-row justify-center">
              <p className="w-full py-2 text-center text-darkElevationPrimary font-bold font-montserratMedium">
                {pickupStoreName}
              </p>
            </div>
            <div className="flex flex-row justify-center">
              <p className="w-full py-2 text-center text-darkElevationPrimary">
                {pickupStoreAddress}
              </p>
            </div>
            <div className="flex flex-row justify-center py-2">
              <div
                className="md:flex items-center gap-2 cursor-pointer
              h-10 text-white
              flex-grow-0
            bg-dark rounded-[20px] px-4 py-2
            text-sm leading-4 font-bold font-montserratMedium
            "
                role="button"
                tabIndex="0"
                onClick={clickPickUpButton}
                onKeyDown={onViewPickupMenuKeyDown}
              >
                <p className="text-center">View Pickup Menu</p>
              </div>
            </div>
          </div>
        )}

        {/* <Link onClick={this.handleAllLocations} to={endpoints.locations}>
          View all locations &gt;
          {' '}
        </Link> */}

        {hasCaptchaError
          ? this.renderCaptchaChallenge()
          : locationSearchError
            ? this.renderErrorUI()
            : null}

        {isBrandRefresh ? (
          !showPickUpButton &&
          ((showUserLocations && showFeaturedLocation) ||
          (!locationSearchLoading &&
            !showLocations &&
            userToken &&
            inputValue.length === 0)) ? (
              <div className="w-full" {...getWidgetPartProps("user-locations")}>
                {showUserLocations && showFeaturedLocation ? (
                  <FeaturedLocation
                    onClick={() =>
                    guardOrderChange(
                      showOrderGuardModal,
                      this.handleCurrentLocationSelect,
                      myAddress,
                      myLocation,
                    )}
                    icon={getCurrentLocationIcon(crosshairIcon, brandRefreshCurrentIcon)}
                    label="Use my current location"
                    value={myAddress}
                    dataPart="current-location"
                  />
              ) : null}
                {!locationSearchLoading &&
              !showLocations &&
              userToken &&
              inputValue.length === 0 ? (
                <div
                  className={`${styles.savedLocation} text-dark`}
                  {...getWidgetPartProps("favorite-bakeries")}
                >
                  <div {...getWidgetPartProps("favorite-bakeries-top")}>
                    <p
                      className="text-darkElevationPrimary font-montserratBold text-lg"
                      {...getWidgetPartProps("section-heading")}
                    >
                      Favorite Bakeries
                    </p>
                  </div>
                  {favoriteBakeries?.length
                    ? favoriteBakeries.map((store) => {
                        const addressComponents = {
                          address1: store.mailingAddress,
                          city: store.city,
                          state: store.state,
                          postcode: store.zip,
                          lat: store.lat,
                          lng: store.lng,
                          countryId: parseInt(store.countryId, 10),
                        };
                        return (
                          <LocationsListItem
                            preserveProductPage={preserveProductPage}
                            key={store.id}
                            to={endpoints.getMenuUrl(store)}
                            id={store.id}
                            isOpen={this.locationIsOpen(store)}
                            closePopup={() => this.handleCloseWidget()}
                            name={store.name}
                            store={store}
                            mailingAddress={store.mailingAddress}
                            city={store.city}
                            state={store.state}
                            zip={store.zip}
                            changeAddress={this.storeIsselected(store)}
                            distanceFrom={store.distanceToStore}
                            history={history}
                            address={store.address}
                            telephone={store.phone}
                            isDeliveryInRange={store.inDeliveryRange}
                            addressComponents={addressComponents}
                            featuredLocation
                            onPickupStoreAddressConfirmed={(addressComponentsArg) => {
                              this.emitEnterAddress(
                                addressComponentsArg,
                                "Saved Address",
                              );
                            }}
                          />
                        );
                      })
                    : null}
                </div>
              ) : null}
              </div>
          ) : null
        ) : (
          <>
            {showUserLocations ? (
              showFeaturedLocation ? (
                <FeaturedLocation
                  onClick={() =>
                    guardOrderChange(
                      showOrderGuardModal,
                      this.handleCurrentLocationSelect,
                      myAddress,
                      myLocation,
                    )}
                  icon={getCurrentLocationIcon(crosshairIcon, brandRefreshCurrentIcon)}
                  label="Use my current location"
                  value={myAddress}
                />
              ) : null
            ) : null}
            {!locationSearchLoading &&
            !showLocations &&
            userToken &&
            inputValue.length === 0 ? (
              <div
                className={`${styles.savedLocation} text-dark border-t-2 border-dotted border-darkElevationPrimary`}
              >
                <p className="text-darkElevationPrimary font-montserratBold text-lg">
                  Favorite Bakeries
                </p>
                {favoriteBakeries?.length
                  ? favoriteBakeries.map((store) => {
                      const addressComponents = {
                        address1: store.mailingAddress,
                        city: store.city,
                        state: store.state,
                        postcode: store.zip,
                        lat: store.lat,
                        lng: store.lng,
                        countryId: parseInt(store.countryId, 10),
                      };
                      return (
                        <LocationsListItem
                          preserveProductPage={preserveProductPage}
                          key={store.id}
                          to={endpoints.getMenuUrl(store)}
                          id={store.id}
                          isOpen={this.locationIsOpen(store)}
                          closePopup={() => this.handleCloseWidget()}
                          name={store.name}
                          store={store}
                          mailingAddress={store.mailingAddress}
                          city={store.city}
                          state={store.state}
                          zip={store.zip}
                          changeAddress={this.storeIsselected(store)}
                          distanceFrom={store.distanceToStore}
                          history={history}
                          address={store.address}
                          telephone={store.phone}
                          isDeliveryInRange={store.inDeliveryRange}
                          addressComponents={addressComponents}
                          featuredLocation
                          onPickupStoreAddressConfirmed={(addressComponentsArg) => {
                            this.emitEnterAddress(
                              addressComponentsArg,
                              "Saved Address",
                            );
                          }}
                        />
                      );
                    })
                  : null}
              </div>
            ) : null}
          </>
        )}

        {/* HERE */}
        {inputValue.length < 1 ? null : !locationSearchLoading &&
          !showLocations &&
          !delivery &&
          locationSearchData &&
          locationSearchData.length > 0 ? (
            <div
              className={
                isDeliveryPickupBrandRefresh()
                  ? `${styles.locationListContainer} w-full`
                  : styles.locationListContainer
              }
              {...getWidgetPartProps("location-search-results")}
            >
              {locationSearchData.map((location) => (
                <DeliveryLocationsListItem
                  isSelected={isModal && myAddress === location.address1}
                  key={location.address1}
                  onClick={() => this.handlePickupItemSelection(location)}
                  coords={{ lat: location.lat, lng: location.lng }}
                  icon={mapPinIcon}
                  address1={location.address1}
                  addressDetails={location.addressDetails}
                />
            ))}
            </div>
        ) : null}

        {!locationSearchLoading && showLocations ? (
          <div className={styles.locationListContainer}>
            {stores.map((store) => (
              <LocationsListItem
                preserveProductPage={preserveProductPage}
                key={store.id}
                to={endpoints.getMenuUrl(store)}
                id={store.id}
                isOpen={this.locationIsOpen(store)}
                closePopup={() => this.handleCloseWidget()}
                name={store.name}
                store={store}
                mailingAddress={store.mailingAddress}
                city={store.city}
                state={store.state}
                zip={store.zip}
                changeAddress={this.storeIsselected(store)}
                distanceFrom={store.distanceToStore}
                history={history}
                address={store.address}
                telephone={store.phone}
                isDeliveryInRange={store.inDeliveryRange}
                onPickupStoreAddressConfirmed={(addressComponentsArg) => {
                  const { selectedSavedLocation } = this.state;
                  const source = this.consumeEnterAddressSource(
                    selectedSavedLocation,
                  );
                  this.pendingAddressSource = null;
                  this.emitEnterAddress(addressComponentsArg, source);
                }}
              />
            ))}
          </div>
        ) : null}
      </div>
    );
  };

  renderDeliveryFulfillmentIcon = (isActive) => {
    if (isDeliveryPickupBrandRefresh()) {
      return <img src={brandRefreshDeliveryIcon} alt="" />;
    }

    return isActive ? (
      <Lottie animationData={truckAnimation} autoPlay loop />
    ) : (
      <Lottie autoplay={false} animationData={truckAnimation} />
    );
  };

  renderPickupFulfillmentIcon = (isActive) => {
    if (isDeliveryPickupBrandRefresh()) {
      return <img src={brandRefreshPickupIcon} alt="" />;
    }

    return isActive ? (
      <Lottie animationData={bakeryAnimation} autoPlay loop />
    ) : (
      <Lottie autoplay={false} animationData={bakeryAnimation} />
    );
  };

  deliveryPickUpWidgetContainer = () => {
    const { delivery, onSelectLocationLoader } = this.state;
    const { addressType, disableCloseButton, showPickUpButton } = this.props;
    const isBrandRefresh = isDeliveryPickupBrandRefresh();
    const mapLightIcon = getMapLightIcon(MapLightIcon, brandRefreshMapLightIcon);
    const closeIcon = getClearDarkIcon(clearDarkIcon, brandRefreshClearDarkIcon);
    const disableCssClass =
      " opacity-60 bg-opacity-60 border-opacity-60 text-opacity-60";
    const hoverCssClass =
      " hover:opacity-100 hover:bg-opacity-100 hover:border-opacity-100 hover:text-opacity-100";

    return (
      <div
        className={`${styles.widgetWrapper}
      fixed inset-0 bg-opacity-25
      backdrop-blur-sm flex justify-center items-center
      zIndex shadow-[0_0_15px_6px_rgba(0,0,0,0.35)]
      bg-darkBlack
      `}
        role="dialog"
        aria-modal="true"
        aria-labelledby="deliveryPickupWidget"
        onKeyDown={(e) => {
          if (e.key === "Escape" || e.key === "Esc") {
            e.preventDefault();
            e.stopPropagation();
            this.handleCloseWidget();
          }
        }}
      >
        <div
          id="modalDeliveryPickupWidget"
          className={`${styles.widgetContainer}

        md:shadow-modalShadow md:dark:shadow-modalDarkShadow
        bg-white w-[600px] flex flex-col p-[20px] md:rounded-[40px]
         h-full md:h-auto md:min-h-[289px] outline-none
      `}
          {...getWidgetRegionProps()}
          onKeyDown={(e) => {
            if (e.key === "Escape" || e.key === "Esc") {
              e.preventDefault();
              e.stopPropagation();
              this.handleCloseWidget();
            }
          }}
        >
          <div
            ref={this.fallbackRef}
            tabIndex="-1"
            className="hidden outline-none"
          >
            FallbackButton
          </div>
          {disableCloseButton ? null : isBrandRefresh ? (
            <div {...getWidgetPartProps("header-wrapper")}>
              <div {...getWidgetPartProps("header-container")}>
                <div
                  role="button"
                  tabIndex="0"
                  id="closeWidget"
                  {...getWidgetPartProps("close-button-mobile")}
                  onClick={() => {
                    this.handleCloseWidget();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      this.handleCloseWidget();
                    }
                  }}
                  aria-label="Close Widget"
                >
                  <img
                    src={closeIcon}
                    alt=""
                    {...getWidgetPartProps("close-button-icon")}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div
              role="button"
              tabIndex="0"
              className="w-full flex md:hidden mb-8 justify-end"
              id="closeWidget"
              onClick={() => {
                this.handleCloseWidget();
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  this.handleCloseWidget();
                }
              }}
              aria-label="Close Widget"
            >
              <img
                src={closeIcon}
                alt=""
                className="w-6 h-6 object-contain"
              />
            </div>
          )}
          {/* WIDGET HEADER */}
          <div
            id="deliveryPickupWidget"
            className="relative flex items-center flex-col gap-4 w-full mx-auto"
            {...getWidgetPartProps("widget-content")}
          >
            {addressType === "shipping" ? (
              <div
                className={`${styles.widgetType} flex gap-4 w-full md:w-96 px-4 lg:px-0  item-center`}
              >
                <p />
              </div>
            ) : (
              <div
                className={
                  isBrandRefresh
                    ? "w-full"
                    : `${styles.widgetType} flex gap-4 w-full md:w-96 px-4 lg:px-0 justify-center item-center mb-1 mt-8`
                }
                {...getWidgetPartProps("fulfillment-toggle")}
              >
                <div
                  role="button"
                  tabIndex="0"
                  id="deliveyWidget"
                  onClick={() => this.chooseDeliveryType(true)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      this.chooseDeliveryType(true);
                    }
                  }}
                  {...getWidgetPartProps("fulfillment-option")}
                  data-selected={isBrandRefresh ? String(delivery) : undefined}
                  className={
                    isBrandRefresh
                      ? "flex flex-col justify-center items-center cursor-pointer"
                      : `${delivery ? styles.chosenType : disableCssClass}
                  flex flex-col justify-center items-center border shadow-lg
                  rounded-[12px]
                  w-[167px] gap-1 h-[128px] bg-transparent 
                  text-dark
                  font-montserratBold cursor-pointer
                  ${hoverCssClass}`
                  }
                >
                  <div
                    className={isBrandRefresh ? undefined : "w-[88px]"}
                    {...getWidgetPartProps("fulfillment-icon")}
                  >
                    {this.renderDeliveryFulfillmentIcon(delivery)}
                  </div>
                  <p {...getWidgetPartProps("fulfillment-label")}>Delivery</p>
                </div>
                <div
                  role="button"
                  tabIndex="0"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      this.chooseDeliveryType(false);
                    }
                  }}
                  onClick={() => this.chooseDeliveryType(false)}
                  id="pickupWidget"
                  {...getWidgetPartProps("fulfillment-option")}
                  data-selected={
                    isBrandRefresh ? String(!delivery) : undefined
                  }
                  className={
                    isBrandRefresh
                      ? "flex flex-col justify-center items-center cursor-pointer"
                      : `${!delivery ? styles.chosenType : disableCssClass}
                  flex flex-col justify-center items-center border shadow-lg
                  rounded-[12px]
                  w-[167px] gap-1 h-[128px] bg-transparent
                  text-dark font-montserratBold cursor-pointer
                  ${hoverCssClass}`
                  }
                >
                  <div
                    className={isBrandRefresh ? undefined : "w-[88px]"}
                    {...getWidgetPartProps("fulfillment-icon")}
                  >
                    {this.renderPickupFulfillmentIcon(!delivery)}
                  </div>

                  <p {...getWidgetPartProps("fulfillment-label")}>Pickup</p>
                </div>
              </div>
            )}
            {disableCloseButton || isBrandRefresh ? null : (
              <div
                role="button"
                tabIndex="0"
                className="absolute right-0 cursor-pointer w-11 h-11 hidden md:flex items-center"
                id="closeWidget"
                aria-label="Close Widget"
                onClick={() => {
                  this.handleCloseWidget(); // eslint-disable-line
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.handleCloseWidget(); // eslint-disable-line
                  }
                }}
              >
                <img
                  src={closeIcon}
                  alt=""
                  className="w-6 h-6 object-contain m-auto"
                />
              </div>
            )}
            {/* WIDGET BODY */}
            <div
              className="w-full"
              {...getWidgetPartProps("widget-body")}
            >
              {delivery ? (
                <this.renderDeliverySection />
              ) : (
                <this.renderPickUpSection />
              )}

              {!isBrandRefresh ? (
                <p className="w-full py-2 text-center text-darkElevationPrimary border-t-[1px] border-darkElevationPrimary">
                  {!delivery
                    ? "Fresh, warm cookies ready for pickup"
                    : "Fresh, warm cookies delivered right to your door"}
                </p>
              ) : null}
            </div>

            {/* Address selection loader overlay */}
            {onSelectLocationLoader && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10,
                  borderRadius: isBrandRefresh ? "12px" : "40px",
                }}
              >
                <Loader />
              </div>
            )}

            {!delivery && !(isBrandRefresh && showPickUpButton) && (
              <div
                className="mx-auto md:hidden text-center relative"
                {...getWidgetPartProps("view-on-map-mobile-footer")}
              >
                <div
                  role="button"
                  tabIndex="0"
                  className={
                    isBrandRefresh
                      ? undefined
                      : ` flex items-center gap-2 cursor-pointer
                w-[190px] h-8 text-white
              bg-dark rounded-[40px] px-4 py-3
              text-sm leading-4 font-bold font-montserratMedium zIndex
              `
                  }
                  {...getWidgetPartProps("view-on-map")}
                  onClick={this.toLocationsPage}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      this.toLocationsPage(); // eslint-disable-line
                    }
                  }}
                >
                  {isBrandRefresh ? (
                    <div {...getWidgetPartProps("view-on-map-content")}>
                      <div {...getWidgetPartProps("view-on-map-inner")}>
                        <img
                          alt=""
                          src={mapLightIcon}
                          {...getWidgetPartProps("pickup-location-icon")}
                        />
                        <p>View on map</p>
                      </div>
                    </div>
                  ) : (
                    <div className="flex gap-2 items-center mx-auto">
                      <img
                        className={`${styles.pickupLocationIcon}`}
                        alt=""
                        src={mapLightIcon}
                      />

                      <p>View on map</p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          {disableCloseButton || !isBrandRefresh ? null : (
            <div
              role="button"
              tabIndex="0"
              id="closeWidget"
              aria-label="Close Widget"
              {...getWidgetPartProps("close-button-desktop")}
              onClick={() => {
                this.handleCloseWidget();
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  this.handleCloseWidget();
                }
              }}
            >
              <img
                src={closeIcon}
                alt=""
                {...getWidgetPartProps("close-button-icon")}
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    return <this.deliveryPickUpWidgetContainer />;
  }
}

DeliveryPickUpWidget.propTypes = {
  preserveProductPage: PropTypes.bool,
  isModal: PropTypes.bool,
  isShippingActive: PropTypes.bool,
  productId: PropTypes.any, // eslint-disable-line
  cmsContent: PropTypes.shape(),
  disableCloseButton: PropTypes.bool,
  showPickUpButton: PropTypes.bool,
  inputValue: PropTypes.string,
  clickPickUpButton: PropTypes.func,
  selectedPopupStore: PropTypes.shape(),
  orderProducts: PropTypes.arrayOf(PropTypes.shape()),
  analyticsPageSection: PropTypes.string,
};

DeliveryPickUpWidget.defaultProps = {
  preserveProductPage: false,
  isModal: false,
  isShippingActive: true,
  productId: null,
  cmsContent: [],
  disableCloseButton: false,
  showPickUpButton: false,
  inputValue: "",
  clickPickUpButton: false,
  selectedPopupStore: {},
  orderProducts: [],
  analyticsPageSection: "",
};

export const mapStateToProps = (state) => {
  const {
    userToken,
    userAddress,
    userCartId,
    userOrderMethod,
    userCart,
    selectedStore,
  } = state.user;
  const { useRecaptcha } = state.elements;
  const { modalObject } = state.elements;
  const orderProducts = state.order?.products || [];
  const { isShippingActive } = state.shipping;
  const { selectedCountry, allCountries, isCountrySelectActive } =
    state.country;
  const { useFullyQualifiedAddressForDelivery } = state.address;
  const { redeemables } = state.loyalty;
  return {
    userToken,
    userAddress,
    userCartId,
    userOrderMethod,
    userCart,
    orderProducts,
    selectedStore,
    modalObject,
    isShippingActive,
    selectedCountry,
    allCountries,
    isCountrySelectActive,
    useFullyQualifiedAddressForDelivery,
    redirectUrl: state.address.redirectUrl,
    redeemables,
    useRecaptcha,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  setUserCart: (value) => dispatch(userActions.setUserCart(value)),
  setUserCartId: (value) => dispatch(userActions.setUserCartId(value)),
  setModalObject: (value) => dispatch(elementsActions.setModalObject(value)),
  setUserOrderMethod: (value) =>
    dispatch(userActions.setUserOrderMethod(value)),
  setUserAddress: (value) => dispatch(userActions.setUserAddress(value)),
  setSelectedStore: (value) => dispatch(userActions.setSelectedStore(value)),
  saveAddress: (value) => dispatch(userActions.saveAddress(value)),
  addressUpdated: (value) => dispatch(addressActions.addressUpdated(value)),
  setAutocompleteSessionToken: (value) =>
    dispatch(elementsActions.setAutocompleteSessionToken(value)),
  setOrderMinAmount: (value) =>
    dispatch(elementsActions.setOrderMinAmount(value)),
  setSelectedCountry: (value) =>
    dispatch(countryActions.setSelectedCountry(value)),
  hideHeaderWidget: () => dispatch(elementsActions.hideHeaderWidget()),
  setVerificationToken: (value) =>
    dispatch(elementsActions.setVerificationToken(value)),
  setVerificationAction: (value) =>
    dispatch(elementsActions.setVerificationAction(value)),
  setVerificationProvider: (value) =>
    dispatch(elementsActions.setVerificationProvider(value)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DeliveryPickUpWidget),
);
